import { IdName } from '../../service/asset';
import { BaseService } from '../../service/base';

export interface RockPitDTO {
    id: IdName;
    colour: string;
    geometry: google.maps.LatLng[];
    capacity: number;
    used: number;
    description: string;
}

export interface RockPitEventDTO {
    assetId: string;
    timestamp: number;
}

/** REST API access
 *
 */
export class RockPitService extends BaseService {
    public cache?: Promise<RockPitDTO[]>;

    public async init() {
        return new Promise((resolve, _reject) => {
            console.log('RockPit Service Loaded');
            resolve('Loaded');
        });
    }

    async deletePit(rockpitId: string) {
        const response = await this.delete<RockPitDTO>(this.url + '/api/' + this.orgid + '/rockpit', rockpitId);
        return response;
    }

    async save(data: RockPitDTO) {
        if (data.id.id == undefined || data.id.id == '') {
            const response = await this.post<RockPitDTO>(this.url + '/api/' + this.orgid + '/rockpit', data);
            return response;
        } else {
            const response = await this.put<RockPitDTO>(this.url + '/api/' + this.orgid + '/rockpit', data);
            return response;
        }
    }

    public cachedFetchData(): Promise<RockPitDTO[]> {
        // Check if the data for the given id is already cached
        if (this.cache) {
            return this.cache;
        }

        // If not cached, fetch the data and store the promise in the cache
        const promise = this.fetchData();
        this.cache = promise;
        return promise;
    }

    private fetchData(): Promise<RockPitDTO[]> {
        const url = this.url + '/api/' + this.orgid + '/rockpit';
        return fetch(url, {
            method: 'GET',
            headers: this.headers(),
        }).then((response) => {
            return response.json();
        });
    }

    async getEvents(rockPitId: string) {
        const response = await this.get<RockPitEventDTO[]>(this.url + '/api/' + this.orgid + '/rockpit/' + rockPitId + '/events');
        return response;
    }
}
